import { useLocation } from "react-router-dom";
import { PublicDataProvider, usePublicData, CLUB_LOGO, mediaUrl } from "./siteData";
import { PublicNavigation } from "./PublicNavigation";
import { PublicFooter } from "./PublicFooter";
import "./public.css";
import { localizeInvalidField, clearFieldMessage } from "./formMessages";
import { resolveMediaUrl } from "../utils/mediaUrl";

const PublicSurface = ({ children }) => {
  const { pathname } = useLocation();
  const { club } = usePublicData();
  const handleImageError = event => {
    const image = event.target;
    if (image.tagName !== "IMG") return;
    const portable = resolveMediaUrl(image.src);
    if (portable && portable !== image.src && image.dataset.mediaRetry !== portable) {
      image.dataset.mediaRetry = portable;
      image.src = portable;
      return;
    }
    const fallback = mediaUrl(club?.logo_url) || CLUB_LOGO;
    if (image.src === fallback || image.src === CLUB_LOGO) return;
    image.dataset.publicImageFallback = "true";
    image.alt = `${image.alt || "Εικόνα"} · Η φωτογραφία δεν είναι διαθέσιμη`;
    image.title = "Η φωτογραφία δεν είναι διαθέσιμη";
    image.src = fallback;
  };
  return <div className="public-site" lang="el" data-public-route={pathname.split("/")[1] || "home"} data-testid="public-site" onErrorCapture={handleImageError}>
    <PublicNavigation />
    <div className="public-content"><main id="public-main" className="public-main" tabIndex={-1} data-testid="public-main" onInvalidCapture={localizeInvalidField} onInputCapture={clearFieldMessage} onChangeCapture={clearFieldMessage}>{children}</main><PublicFooter /></div>
  </div>;
};

export const PublicShell = ({ children }) => <PublicDataProvider><PublicSurface>{children}</PublicSurface></PublicDataProvider>;